/**
 * Droits de l'utilisateur courant, pour masquer les entrees d'interface qu'il
 * ne peut pas utiliser.
 *
 * Ce masquage ne protege rien : la protection reelle est cote serveur
 * (`server/utils/auth.ts`), ou elle intercepte aussi les appels directs a
 * l'API. Les deux s'appuient sur les memes regles (`shared/utils/authorization`)
 * pour rester alignes.
 */
export function useAuthorization() {
  const store = useAuthStore()

  /** Entrer dans l'application : exige un rôle applicatif attribué. */
  const canAccess = computed(() => canAccessApp(store.user))

  /** Import et exports de la base adherents. */
  const isAdmin = computed(() => canManageData(store.user))

  /** Export RNIC (donnees publiques) : tout le monde sauf les lecteurs. */
  const canExportRnic = computed(() => canExportRnicData(store.user))

  /** Creer, modifier et supprimer des donnees metier. */
  const canWrite = computed(() => canWriteData(store.user))

  /**
   * Journal technique : superadministrateurs du SSO uniquement.
   *
   * Le seuil est plus haut qu'`isAdmin` parce que la matiere l'est aussi : les
   * lignes du journal citent des adresses IP et des messages d'erreur qui
   * exposent le fonctionnement interne. Le controle porte sur le role global,
   * etre administrateur ici ne disant rien du niveau de confiance a l'echelle
   * du SSO.
   */
  const isSuperAdmin = computed(() => isGlobalSuperAdmin(store.user))

  return { canAccess, isAdmin, canExportRnic, canWrite, isSuperAdmin }
}
